/**
 * Browser-side half of the WAF-bypass envelope.
 *
 * Kept separate from payload-codec.ts on purpose: that module imports
 * node:zlib to decode payload_gz64 and can therefore only ever run in a
 * route handler. Importing it from a client component pulls a Node builtin
 * into the browser bundle. This file is the client-safe counterpart -- no
 * imports at all -- and tests/lib/payload-encode.test.ts pins the two
 * together as exact inverses.
 *
 * Encodes to payload_b64 (plain base64), never payload_gz64: the gzip
 * variant is itself blocked by SQLI-942450 on some routes (see
 * /api/sessions/save), whereas plain base64 is the variant chat-v3 has run
 * on in production since 2026-06.
 */

/** base64-encode any JSON-serializable payload for a `{ payload_b64 }` envelope. */
export function encodePayloadBase64(payload: unknown): string {
  const json = JSON.stringify(payload)
  // btoa() operates on Latin-1 code units and throws InvalidCharacterError on
  // any character above U+00FF. Real CRF text is full of them (≤, °, µ, en
  // dashes, smart quotes), so widen to UTF-8 bytes first.
  const bytes = new TextEncoder().encode(json)
  let binary = ''
  for (const b of bytes) binary += String.fromCharCode(b)
  return btoa(binary)
}

/** Wrap a payload as the envelope body a WAF-fronted BFF route expects. */
export function wrapPayload(payload: unknown): { payload_b64: string } {
  return { payload_b64: encodePayloadBase64(payload) }
}
